import getAffiliationsInfoLogic from "../Application/GetAffiliations.logic";

export default async function getAffiliationsInfo(zone, betweenDates){
  return getAffiliationsInfoLogic(zone, betweenDates);
}